<template>
    <div>
        <v-header headerTitle="定制事项清单" :isShowIcon="true"></v-header>
        <van-tabs v-model="active" class="tabs">
            <van-tab>
                <div slot="title" class="title">
                    <img src="@/assets/images/icon1.svg" alt="">
                    <div>立项用地规划许可</div>
                </div>
            </van-tab>
            <van-tab>
                <div slot="title" class="title">
                    <img src="@/assets/images/icon2.svg" alt="">
                    <div>工程建设许可</div>
                </div>
            </van-tab>
            <van-tab>
                <div slot="title" class="title">
                    <img src="@/assets/images/icon3.svg" alt="">
                    <div>施工许可</div>
                </div>
            </van-tab>
            <van-tab>
                <div slot="title" class="title">
                    <img src="@/assets/images/icon4.svg" alt="">
                    <div>竣工验收</div>
                </div>
            </van-tab>
        </van-tabs>
        <div class="custom">
            <div class="card">
                <van-search v-model="searchValue" shape="round" placeholder="请输入搜索关键词" />
                <van-checkbox-group v-model="selectResult" v-show="active===0">
                    <van-cell-group>
                        <van-cell :title="`${index+1}、${item.name}`" v-for="(item, index) in siteList" :key="index">
                            <van-checkbox :name="item.id" />
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
                <div v-show="active===1">
                    自行填充
                </div>
                <div v-show="active===2">
                    自行填充
                </div>
                <div v-show="active===3">
                    自行填充
                </div>
            </div>
        </div>
        <div class="bot-btns">
            <van-button class="one" @click="selectList()">
                <span>已选清单</span>
                <span class="value">(5)</span>
            </van-button>
            <van-button class="two">暂存</van-button>
            <van-button class="three" @click="submit()">提交</van-button>
        </div>
    </div>
</template>
<script>
export default {
    name: "",
    components: {
        'v-header': () => import('@/components/VHeader/index.vue')
    },
    data() {
        return {
            active: 0,
            searchValue: '',
            selectResult: [],
            siteList: [
                { id: '1', name: '新建、改建、扩建生产、储存危险化学品的建设项目安全条件审查' },
                { id: '2', name: '建设工程文物保护许可' },
                { id: '3', name: '一般工程抗震设防要求审定' },
                { id: '4', name: '建设用地规划许可证（延期）' },
                { id: '5', name: '涉及国家安全事项的建设项目新建、改建、扩建' },
                { id: '1', name: '新建、改建、扩建生产、储存危险化学品的建设项目安全条件审查' },
                { id: '2', name: '建设工程文物保护许可' },
                { id: '3', name: '一般工程抗震设防要求审定' },
                { id: '4', name: '建设用地规划许可证（延期）' },
                { id: '5', name: '涉及国家安全事项的建设项目新建、改建、扩建' },
            ]
        };
    },
    methods: {
        selectList() {
            this.$router.push('/select')
        },
        submit() {
            this.$router.push('/result')
        }
    },
};
</script>
<style lang="less" scoped>
.tabs {
    border-top: 1px solid #eee;

    ::v-deep {
        .van-tab__text {

            font-size: 14px;
            color: #000;
            font-weight: 400;

            .title {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 4px 0;

                img {
                    width: 14px;
                    height: 14px;
                }
            }
        }

        .van-tab {
            //flex布局宽度自适应
            flex: 1 1 auto;
        }

        .van-tabs__wrap {
            height: 52px;
        }

        .van-tabs__line {
            height: 2px;
            background: #0273C7;
        }

        .van-tab--active {
            .title {
                color: #0273C7;
            }
        }
    }
}

.custom {
    padding: 12px 16px;
    height: calc(100vh - 52px - 64px - 46px);

    .card {
        background: #fff;
        height: 100%;
        overflow: scroll;
        border-radius: 6px;

        ::v-deep {
            .van-search__content {
                border: 1px solid #eee;
                background: #fff;
            }

            .van-hairline--top-bottom::after {
                border-width: 0;
            }

            .van-cell {
                align-items: center;
                column-gap: 10px;

                .van-cell__title {
                    order: 1;
                    font-size: 15px;
                    font-weight: 400;
                    color: #000;
                }

                .van-cell__value {
                    order: 0;
                    flex: 0 1 auto;
                }

            }

            .van-checkbox__icon {
                height: 16px;
                height: 16px;

                .van-icon {
                    width: 16px;
                    height: 16px;
                    line-height: 16px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                }
            }

            .van-checkbox__icon--checked {
                .van-icon-success {
                    background: #0273C7;
                    color: #fff;
                }
            }
            .van-checkbox-group{
                .van-cell{
                    padding: 16px;
                    &::after{
                        border-bottom: 1px solid #eee;
                        left: 0;
                        right: 0;
                    }
                }
            }
        }
    }
}

.bot-btns {
    background: #FFF;
    height: 64px;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .van-button {
        height: 40px;
        line-height: 40px;
        border-radius: 6px;
        padding: 0 25px;
        font-size: 16px;
        font-weight: 600;
        color: #8B8F9A;

    }

    .one {
        border: 1px solid #D9DADE;

        .value {
            color: #0273C7;
            margin-left: 5px;
        }
    }

    .two {
        border: 1px solid #97C5E7;
        color: #0273C7;
    }

    .three {
        background: #0273C7;
        color: #fff;
    }
}
</style>